<template>
  <div class="newAddPatients">
    <el-dialog width="70%" v-if="showDialog" :modal="false" center :close-on-click-modal="false" :destroy-on-close="true"
      :visible.sync="showDialog" :title="title">
      <el-container class="container">
        <el-descriptions :column="4" border>
          <el-descriptions-item :span="2" label="*姓名">
            <el-input v-model="baseFormData.name" placeholder=""></el-input>
          </el-descriptions-item>
          <el-descriptions-item :span="2" label="*性别">
            <el-select v-model="baseFormData.gender" placeholder="请选择">
              <el-option v-for="item in sexOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item :span="2" label="*关系">
            <el-select v-model="relationFormData.relationName" placeholder="请选择">
              <el-option v-for="(item, index) in relationNameData" :key="index" :value="item.value" :label="item.label"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item :span="2" label="*身份证号">
            <el-input v-model="baseFormData.idcard" placeholder=""></el-input>
          </el-descriptions-item>
          <el-descriptions-item :span="2" label="工作单位">
            <el-input v-model="baseFormData.workDept" placeholder=""></el-input>
          </el-descriptions-item>
          <el-descriptions-item :span="2" label="*电话">
            <el-input v-model="baseFormData.phone" placeholder=""></el-input>
          </el-descriptions-item>
          <el-descriptions-item :span="2" label="*身高(cm)">
            <el-input v-model="detail.height" placeholder=""></el-input>
          </el-descriptions-item>
          <el-descriptions-item :span="2" label="*体重(kg)">
            <el-input v-model="detail.weight" placeholder=""></el-input>
          </el-descriptions-item>
          <el-descriptions-item :span="2" label="*腰围(cm)">
            <el-input v-model="detail.waist" placeholder=""></el-input>
          </el-descriptions-item>
          <el-descriptions-item :span="2" label="*血压(mmHg)">
            <el-input style="width: 100px" v-model="detail.sbp" placeholder="收缩压"></el-input>/<el-input v-model="detail.dbp" style="width: 100px" placeholder="舒张压"></el-input>
          </el-descriptions-item>
          <el-descriptions-item :span="2" label="糖尿病家族史">
            <el-select v-model="detail.diabetFamily" placeholder="请选择">
              <el-option v-for="item in familyHistoryOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item :span="2" label="*常住类型">
            <el-select v-model="baseFormData.residFlag" placeholder="请选择">
              <el-option v-for="(item, index) in residFlagList" :key="index" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item :span="2" label="*民族">
            <el-select v-model="baseFormData.nation" placeholder="请选择">
              <el-option v-for="(item, index) in nationList" :key="index" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item :span="2" label="*血型">
            <el-select v-model="baseFormData.bloodType" placeholder="请选择">
              <el-option v-for="(item, index) in bloodTypeData" :key="index" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item :span="2" label="*RH">
            <el-select v-model="baseFormData.bloodRh" placeholder="请选择">
              <el-option v-for="(item, index) in RHData" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item :span="2" label="文化程度">
            <el-select v-model="baseFormData.edu" placeholder="请选择">
              <el-option v-for="(item, index) in educationData" :key="index" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item :span="2" label="*机构名称">
            <patientTree @input="input" :treeData="treeData"></patientTree>
          </el-descriptions-item>
          <el-descriptions-item :span="2" label="*医疗费用支付方方式">
            <el-select v-model="baseFormData.payWay" placeholder="请选择">
              <el-option v-for="(item, index) in payWayData" :key="index" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item :span="2" label="*是否纳入规范管理">
            <el-select v-model="baseFormData.isDiabetStdManage" placeholder="请选择">
              <el-option label="是" value="是"></el-option>
              <el-option label="否" value="否"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item contentClassName="address" :span="4" label="*现住址">
            <el-select v-model="baseFormData.provinceCode" @change="provinceCodeChange" placeholder="省">
              <el-option v-for="(item, index) in provinceData" :key="index" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
            <el-select @change="cityCodeChange" v-model="baseFormData.cityCode" placeholder="市">
              <el-option v-for="(item, index) in cityData" :key="index" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
            <el-select @change="countyCodeChange" v-model="baseFormData.countyCode" placeholder="区">
              <el-option v-for="(item, index) in countyData" :key="index" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
            <el-select @change="townCodeChange" v-model="baseFormData.townCode" placeholder="乡镇">
              <el-option v-for="(item, index) in townData" :key="index" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
            <el-select @change="villageCodeChange" v-model="baseFormData.villageCode" placeholder="村">
              <el-option v-for="(item, index) in villageData" :key="index" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
            <el-input class="houseNumber" style="width:250px" v-model="baseFormData.houseNumber" placeholder="门牌号"></el-input>
          </el-descriptions-item>
          <el-descriptions-item contentClassName="desease" :span="4" label="既往史">
            <el-descriptions :column="1" border>
              <el-descriptions-item :span="4" label="*药物过敏史">
                <el-checkbox-group class="checkGroup" @change="allergyDataChange" v-model="allergyDrugArr">
                  <el-checkbox v-for="item in allergyData" :value="item.value" :label="item.value"
                    :key="item.value"></el-checkbox>
                </el-checkbox-group>
              </el-descriptions-item>

              <el-descriptions-item :span="4" label="*暴露史">
                <el-checkbox-group class="checkGroup" @change="envRiskChange" v-model="envRiskArr">
                  <el-checkbox v-for="item in envRiskData" :label="item.value" :value="item.value"
                    :key="item.value"></el-checkbox>
                </el-checkbox-group>
              </el-descriptions-item>

              <el-descriptions-item contentClassName="deseasesClass" :span="4" label="*疾病史(必填项,若无疾病史,疾病名称选'无')">
                <el-button type="primary" size="small" @click="addDiseasesItem()">新增疾病史</el-button>
                <el-descriptions :column="1" border>
                  <el-descriptions-item class="medicines" label="疾病" v-for="(item, index) in diseases" :key="index">
                    <el-descriptions :column="4" border>
                      <el-descriptions-item span="2" label="疾病名称">
                        <el-select v-model="item.name" placeholder="选择疾病">
                          <el-option v-for="(item, index) in diseasesData" :key="index" :label="item.label"
                            :value="item.value"></el-option>
                        </el-select>
                      </el-descriptions-item>
                      <el-descriptions-item span="2" label="确诊时间">
                        <el-date-picker v-model="item.createTime" placeholder=""></el-date-picker>
                      </el-descriptions-item>
                      <el-descriptions-item span="2" label="操作">
                        <el-button type="primary" size="small" @click="deleteDiseasesItem(index)">删除</el-button>
                      </el-descriptions-item>
                    </el-descriptions>
                  </el-descriptions-item>
                </el-descriptions>
              </el-descriptions-item>

              <el-descriptions-item contentClassName="deseasesClass" :span="4" label="*家族史(必填项,若无家族史,名称选'无')">
                <el-button type="primary" size="small" @click="addFamilyHistoryItem()">新增家族史</el-button>
                <el-descriptions :column="1" border>
                  <el-descriptions-item class="medicines" label="疾病" v-for="(item, index) in familyHistory" :key="index">
                    <el-descriptions :column="4" border>
                      <el-descriptions-item span="2" label="疾病名称">
                        <el-select v-model="item.name" placeholder="选择疾病">
                          <el-option v-for="(item, index) in diseasesData" :key="index" :label="item.label"
                            :value="item.value"></el-option>
                        </el-select>
                      </el-descriptions-item>
                      <el-descriptions-item span="2" label="关系">
                        <el-select v-model="item.category" placeholder="选择疾病">
                          <el-option v-for="(item, index) in categoryData" :key="index" :label="item.label"
                            :value="item.value"></el-option>
                        </el-select>
                      </el-descriptions-item>
                      <el-descriptions-item span="2" label="操作">
                        <el-button type="primary" size="small" @click="deleteFamilyHistoryItem(index)">删除</el-button>
                      </el-descriptions-item>
                    </el-descriptions>
                  </el-descriptions-item>
                </el-descriptions>
              </el-descriptions-item>

              <el-descriptions-item contentClassName="deseasesClass" :span="4" label="手术史">
                <el-button type="primary" size="small" @click="addSurgeryItem()">新增手术史</el-button>
                <el-descriptions :column="1" border>
                  <el-descriptions-item class="medicines" label="手术" v-for="(item, index) in surgerys" :key="index">
                    <el-descriptions :column="4" border>
                      <el-descriptions-item span="2" label="手术名称">
                        <el-input v-model="item.name"></el-input>
                      </el-descriptions-item>
                      <el-descriptions-item span="2" label="确诊时间">
                        <el-date-picker v-model="item.createTime" placeholder=""></el-date-picker>
                      </el-descriptions-item>
                      <el-descriptions-item span="2" label="操作">
                        <el-button type="primary" size="small" @click="deleteSurgeryItem(index)">删除</el-button>
                      </el-descriptions-item>
                    </el-descriptions>
                  </el-descriptions-item>
                </el-descriptions>
              </el-descriptions-item>

              <el-descriptions-item contentClassName="deseasesClass" :span="4" label="外伤史">
                <el-button type="primary" size="small" @click="addWoundItem()">新增外伤史</el-button>
                <el-descriptions :column="1" border>
                  <el-descriptions-item class="medicines" label="外伤" v-for="(item, index) in wounds" :key="index">
                    <el-descriptions :column="4" border>
                      <el-descriptions-item span="2" label="名称">
                        <el-input v-model="item.name"></el-input>
                      </el-descriptions-item>
                      <el-descriptions-item span="2" label="确诊时间">
                        <el-date-picker v-model="item.createTime" placeholder=""></el-date-picker>
                      </el-descriptions-item>
                      <el-descriptions-item span="2" label="操作">
                        <el-button type="primary" size="small" @click="deleteWoundItem(index)">删除</el-button>
                      </el-descriptions-item>
                    </el-descriptions>
                  </el-descriptions-item>
                </el-descriptions>
              </el-descriptions-item>

              <el-descriptions-item contentClassName="deseasesClass" :span="4" label="输血史">
                <el-button type="primary" size="small" @click="addBloodTransReason()">新增输血史</el-button>
                <el-descriptions :column="1" border>
                  <el-descriptions-item class="medicines" label="输血" v-for="(item, index) in bloodTransHistory"
                    :key="index">
                    <el-descriptions :column="4" border>
                      <el-descriptions-item span="2" label="原因">
                        <el-input v-model="item.name" placeholder="输入原因"></el-input>
                      </el-descriptions-item>
                      <el-descriptions-item span="2" label="确诊时间">
                        <el-date-picker v-model="item.createTime" placeholder=""></el-date-picker>
                      </el-descriptions-item>
                      <el-descriptions-item span="2" label="操作">
                        <el-button type="primary" size="small" @click="deleteBloodTransReason(index)">删除</el-button>
                      </el-descriptions-item>
                    </el-descriptions>
                  </el-descriptions-item>
                </el-descriptions>
              </el-descriptions-item>
            </el-descriptions>
          </el-descriptions-item>
        </el-descriptions>
      </el-container>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showDialog = false">关闭</el-button>
        <el-button type="primary" @click="saveBaseInfo">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import patientTree from './components/patientTree.vue';

import {
  getUserInfos,
  addPatientList,
  getAreaList,
  updateContactList
} from "@/api/health/Patients";
import { addPatientEasyillDiabetsModel } from "@/api/health/EhrQuery";

// import { log } from 'console';

export function transListToTreeData(list, RootValue) {
  let arr = [], array = [];
  list.forEach((item, index) => {
    //如果数据对象的pid为 '' 说明数据为根节点
    if (item.parentId == RootValue) {
      let children = transListToTreeData(list, item.deptId); //寻找id等于该对象pid的数据，为它的子节点,返回一个数组
      console.log(children, index);
      if (children.length) {
        item.children = children; //往对象添加一个children属性，属性值为一个数组
      }
      arr.push({ label: item.name, children: item.children });
    }
  });
  return arr;
}
export default {
  components: { patientTree },
  props: {
    pInfo: null
  },
  data() {
    return {
      treeData: [],
      showDialog: false,
      title: "新建联系人居民档案",
      detail: {
        patientId: null,
        patientName: null,
        healthNo: null,
        idcard: null,
        gender: null,
        age: null,
        bmi: null,
        waist: null,
        sbp: null,
        dbp: null,
        diabetFamily: "无家族史"
      },
      relationFormData: {
        id: null,
        healthNo: null,
        contactName: null,
        contactPhone: null,
        relationName: null
      },
      familyHistoryOptions: [
        {
          value: "有家族史",
          label: "有家族史",
        },
        {
          value: "无家族史",
          label: "无家族史",
        },
      ],
      sexOptions: [
        {
          value: "男",
          label: "男",
        },
        {
          value: "女",
          label: "女",
        },
      ],
      residFlagList: [
        {
          value: "本地户口",
          label: "本地户口"
        },
        {
          value: "非本地户口",
          label: "非本地户口"
        }
      ],
      nationList: [
        {
          value: "汉族",
          label: "汉族"
        },
        {
          value: "少数民族",
          label: "少数民族"
        }
      ],
      payWayData: [
        {
          value: '城镇职工基本医疗保险',
          label: "城镇职工基本医疗保险"
        },
        {
          value: '城镇居民基本医疗保险',
          label: "城镇居民基本医疗保险"
        },
        {
          value: '新型农村合作医疗',
          label: "新型农村合作医疗"
        },
        {
          value: '贫困救助',
          label: "贫困救助"
        },
        {
          value: '商业医疗保险',
          label: "商业医疗保险"
        },
        {
          value: '全公费',
          label: "全公费"
        },
        {
          value: '全自费',
          label: "全自费"
        },
        {
          value: '其他',
          label: "其他"
        }
      ],
      bloodTypeData: [
        {
          value: 'A型',
          label: "A型"
        },
        {
          value: 'B型',
          label: "B型"
        },
        {
          value: 'O型',
          label: "O型"
        },
        {
          value: 'AB型',
          label: "AB型"
        },
        {
          value: '不详',
          label: "不详"
        }
      ],
      RHData: [
        {
          value: '阴性',
          label: "阴性"
        },
        {
          value: '阳性',
          label: "阳性"
        },
        {
          value: '不详',
          label: "不详"
        }
      ],
      educationData: [
        {
          value: '研究生',
          label: "研究生"
        },
        {
          value: '大学本科',
          label: "大学本科"
        },
        {
          value: '大学专科和专科学校',
          label: "大学专科和专科学校"
        },
        {
          value: '中等专业学校',
          label: "中等专业学校"
        },
        {
          value: '技工学校',
          label: "技工学校"
        },
        {
          value: '高中',
          label: "高中"
        },
        {
          value: '初中',
          label: "初中"
        },
        {
          value: '小学',
          label: "小学"
        },
        {
          value: '文盲或半文盲',
          label: "文盲或半文盲"
        },
        {
          value: '不详',
          label: "不详"
        }
      ],
      vocationData: [
        {
          value: '国家机关、党群组织、企业、事业单位负责人',
          label: "国家机关、党群组织、企业、事业单位负责人"
        },
        {
          value: '专业技术人员',
          label: "专业技术人员"
        },
        {
          value: '办事人员和有关人员',
          label: "办事人员和有关人员"
        },
        {
          value: '商业、服务业人员',
          label: "商业、服务业人员"
        },
        {
          value: '农、林、牧、渔、水利业生产人员',
          label: "农、林、牧、渔、水利业生产人员"
        },
        {
          value: '生产、运输设备操作人员及有关人员',
          label: "生产、运输设备操作人员及有关人员"
        },
        {
          value: '军人',
          label: "军人"
        },
        {
          value: '不便分类的其他从业人员',
          label: "不便分类的其他从业人员"
        },
        {
          value: '无职业',
          label: "无职业"
        }
      ],
      allergyData: [
        {
          value: '无',
          label: "无",
        },
        {
          value: '青霉素',
          label: "青霉素",
        },
        {
          value: '磺胺',
          label: "磺胺",
        },
        {
          value: '链霉素',
          label: "链霉素",
        },
        {
          value: '其他',
          label: "其他",
        }
      ],
      diseasesData: [
        {
          value: '无',
          text: "无"
        },
        {
          value: '高血压',
          text: "高血压"
        },
        {
          value: '糖尿病',
          text: "糖尿病"
        },
        {
          value: '冠心病',
          text: "冠心病"
        },
        {
          value: '慢性阻塞性肺疾病',
          text: "慢性阻塞性肺疾病"
        },
        {
          value: '恶性肿瘤',
          text: "恶性肿瘤"
        },
        {
          value: '脑卒中',
          text: "脑卒中"
        },
        {
          value: '严重精神障碍',
          text: "严重精神障碍"
        },
        {
          value: '结核病',
          text: "结核病"
        },
        {
          value: '肝炎',
          text: "肝炎"
        },
        {
          value: '其他法定传染病',
          text: "其他法定传染病 "
        },
        {
          value: '职业病',
          text: "职业病"
        },
        {
          value: '其他',
          text: "其他"
        }
      ],
      categoryData: [
        {
          value: '家族史无',
          text: "家族史无"
        },
        {
          value: '家族史父亲',
          text: "家族史父亲"
        },
        {
          value: '家族史母亲',
          text: "家族史母亲"
        },
                {
          value: '家族史子女',
          text: "家族史子女"
        },
        {
          value: '家族史兄弟姐妹',
          text: "无家族史兄弟姐妹"
        }
      ],
      envRiskData: [
        {
          value: '无',
          label: "无",
        },
        {
          value: '化学品',
          label: "化学品",
        },
        {
          value: '毒物',
          label: "毒物",
        },
        {
          value: '射线',
          label: "射线",
        }
      ],
      relationNameData: [
        {
          value: "配偶",
          label: "配偶"
        },
        {
          value: "子",
          label: "子"
        },
        {
          value: "女",
          label: "女"
        },
        {
          value: "孙子、孙女或外孙子、外孙女",
          label: "孙子、孙女或外孙子、外孙女"
        },
        {
          value: "父母",
          label: "父母"
        },
        {
          value: "祖父母或外祖父母",
          label: "祖父母或外祖父母"
        },
      ],
      allergyDrugArr: ["无"],
      envRiskArr: ["无"],
      baseFormData: {
        healthNo: null,
        name: null,
        gender: null,
        birthday: null,
        idcardType: null,
        idcard: null,
        workDept: null,
        phone: null,
        residFlag: "本地户口",
        nation: "汉族",
        bloodType: "不详",
        bloodRh: "不详",
        edu: null,
        vocation: null,
        marriage: null,
        payWay: null,
        isDiabetStdManage: null,
        allergyDrug: null,
        envRisk: null,
        geneticDiseaseHistory: null,
        kitchenExhaustCode: null,
        fuel: null, //燃料类型
        drink: null, //饮水
        toilet: null, //厕所
        poultry: null, //禽畜栏
        managerHospital: null,
        province: null,
        city: null,
        county: null,
        town: null,
        village: null,
        provinceCode: null,
        cityCode: null,
        countyCode: null,
        townCode: null,
        villageCode: null,
        houseNumber: null,
        creator: 'web',
        diseases: [],
        surgerys: [],
        wounds: [],
        bloodTransHistory: [],
        familyHistory: [],
        deformity: null,
      },
      provinceData: [],
      cityData: [],
      countyData: [],
      townData: [],
      villageData: [],
      diseases: [{
        name: "无",
        category: '疾病史',
        createTime: null
      }],
      surgerys: [{
        name: null,
        category: '手术史',
        createTime: null
      }],
      wounds: [{
        name: null,
        category: '外伤史',
        createTime: null
      }],
      bloodTransHistory: [{
        name: null,
        category: '输血史',
        createTime: null
      }],
      familyHistory: [{
        name: "无",
        category: "家族史无",
        createTime: null,
      }],
    }
  },
  created() {
    this.getManageHospital();
  },
  methods: {
    async init(value) {
      console.log(value, "xinjianlianxiren")
      this.baseFormData.parentId = value.parentId;
      this.relationFormData = {
        id: value.id,
        healthNo: value.healthNo,
        contactName: value.contactName,
        contactPhone: value.contactPhone,
        relationName: value.relationName
      };
      this.relationFormData.hisPatientId = value.patientId;
      this.diseases = [{
        name: "无",
        category: '疾病史',
        createTime: null
      }];
      this.surgerys = [{
        name: null,
        category: '手术史',
        createTime: null
      }];
      this.wounds = [{
        name: null,
        category: '外伤史',
        createTime: null
      }];
      this.bloodTransHistory = [{
        name: null,
        category: '输血史',
        createTime: null
      }];
      this.familyHistory = [{
        name: "无",
        category: "家族史无",
        createTime: null,
      }];
      this.allergyDrugArr = ["无"];
      this.envRiskArr = ["无"];
      this.detail = {
        patientId: null,
        patientName: null,
        healthNo: null,
        idcard: null,
        gender: null,
        age: null,
        bmi: null,
        waist: null,
        sbp: null,
        dbp: null,
        diabetFamily: "无家族史"
      };
      this.baseFormData = {
        healthNo: null,
        name: value.contactName,
        gender: null,
        birthday: null,
        idcardType: null,
        idcard: null,
        workDept: null,
        phone: value.contactPhone,
        contactName: null,
        contactPhone: null,
        residFlag: "本地户口",
        nation: "汉族",
        bloodType: "不详",
        bloodRh: "不详",
        edu: null,
        vocation: null,
        marriage: null,
        payWay: null,
        isDiabetStdManage: null,
        allergyDrug: null,
        envRisk: null,
        geneticDiseaseHistory: null,
        kitchenExhaustCode: null,
        fuel: null, //燃料类型
        drink: null, //饮水
        toilet: null, //厕所
        poultry: null, //禽畜栏
        managerHospital: null,
        province: null,
        city: null,
        county: null,
        town: null,
        village: null,
        provinceCode: null,
        cityCode: null,
        countyCode: null,
        townCode: null,
        villageCode: null,
        houseNumber: null,
        creator: 'web',
        diseases: [],
        surgerys: [],
        wounds: [],
        bloodTransHistory: [],
        familyHistory: [],
        deformity: null,
      }
      this.getProvinceData();
      this.showDialog = true;
    },
    setDialogClosed() {
      this.showDialog = false;
    },
    getProvinceData() {
      var arr = [];
      getAreaList({ level: 1, page: 1, pageSize: 100 }).then(res => {
        if (res.msg == "success") {
          var data = res.data;
          var records = data.records;
          records.map((item, index) => {
            arr.push(
              Object.assign({
                value: item.code,
                label: item.name
              })
            )
          })
          this.provinceData = arr;
          this.baseFormData.provinceCode = 370000000000;
          this.getAreaData(this.baseFormData.provinceCode, 'city');
    
          this.baseFormData.cityCode = 370200000000;
          this.getAreaData(this.baseFormData.cityCode, 'country');
    
          this.baseFormData.countyCode = 370211000000;
          this.getAreaData(this.baseFormData.countyCode, 'town');
        } else {

        }
      }).catch(err => {
        console.log(err);
      })
    },
    addDiseasesItem() {
      this.diseases.push({
        name: null,
        category: '疾病史',
        createTime: null
      });
    },
    deleteDiseasesItem(index) {
      this.diseases.splice(index, 1);
    },
    addSurgeryItem() {
      this.surgerys.push({
        name: null,
        category: '手术史',
        createTime: null
      });
    },
    deleteSurgeryItem(index) {
      this.surgerys.splice(index, 1);
    },
    addWoundItem() {
      this.wounds.push({
        name: null,
        category: '外伤史',
        createTime: null
      });
    },
    deleteWoundItem(index) {
      this.wounds.splice(index, 1);
    },
    addBloodTransReason() {
      this.bloodTransHistory.push({
        name: null,
        category: '输血史',
        createTime: null
      });
    },
    deleteBloodTransReason(index) {
      this.bloodTransHistory.splice(index, 1);
    },
    addFamilyHistoryItem() {
      this.familyHistory.push({
        name: null,
        category: "家族史无",
        createTime: null
      });
    },
    deleteFamilyHistoryItem(index) {
      this.familyHistory.splice(index, 1);
    },
    allergyDataChange(e) {
      if (e.at(-1) == "无") {
        this.allergyDrugArr = ['无'];
      } else {
        if (this.allergyDrugArr.indexOf("无") != -1) {
          this.allergyDrugArr.splice(this.allergyDrugArr.indexOf('无'), 1)
        }
      }
    },
    envRiskChange(e) {
      if (e.at(-1) == "无") {
        this.envRiskArr = ['无'];
      } else {
        if (this.envRiskArr.indexOf("无") != -1) {
          this.envRiskArr.splice(this.envRiskArr.indexOf('无'), 1)
        }
      }
    },
    getAreaData(parentcode, type) {
      var arr = [];
      var params = {
        pcode: parentcode
      }
      getAreaList(params).then(res => {
        if (res.msg == "success") {
          var data = res.data;
          var records = data.records;
          records.map((item, index) => {
            arr.push(
              Object.assign({
                value: item.code,
                label: item.name
              })
            )
          })
          if (type == "city") {
            this.cityData = arr;
          }
          if (type == "country") {
            this.countyData = arr;
          }
          if (type == "town") {
            this.townData = arr;
          }
          if (type == "village") {
            this.villageData = arr;
          }
        } else { }
      }).catch(err => {
        console.log(err);
      })
    },
    provinceCodeChange(e) {
      console.log(e)
      this.getAreaData(e, 'city');

      this.baseFormData.cityCode = null;
      this.baseFormData.countyCode = null;
      this.baseFormData.townCode = null;
      this.baseFormData.villageCode = null;
    },
    cityCodeChange(e) {
      this.getAreaData(e, 'country');

      this.baseFormData.countyCode = null;
      this.baseFormData.townCode = null;
      this.baseFormData.villageCode = null;
    },
    countyCodeChange(e) {
      this.getAreaData(e, 'town');

      this.baseFormData.townCode = null;
      this.baseFormData.villageCode = null;
    },
    townCodeChange(e) {
      this.getAreaData(e, 'village');

      this.baseFormData.villageCode = null;
    },
    villageCodeChange(e) {

    },
    // 机构返显
    input(value) {
      this.baseFormData.managerHospital = value[0];
    },
    // 获取机构名称
    getManageHospital() {
      let params = {}
      getUserInfos(params).then((res) => {
        if ((res.msg = "success")) {
          this.managerHospitalList = res.data.hospitals;
          this.$nextTick(() => {
            if(this.managerHospitalList.length == 1) {
              this.treeData = [{label: this.managerHospitalList[0].name, children: null}]
            } else {
              this.treeData = transListToTreeData(this.managerHospitalList, res.data.hospitalId)
              console.log(this.treeData);
            }
          })
        }
      });
    },
    // 计算年龄
    getAge(birthday) {
      if (birthday == null) return "";

      var birthdays = new Date(birthday.replace(/-/g, "/"));
      let d = new Date();
      let age =
        d.getFullYear() -
        birthdays.getFullYear() -
        (d.getMonth() < birthdays.getMonth() ||
          (d.getMonth() == birthdays.getMonth() &&
            d.getDate() < birthdays.getDate())
          ? 1
          : 0);
      return age;
    },
    saveBaseInfo() {
      if (!this.baseFormData.name) {
        this.$message({
          message: '请输入姓名',
          type: "error"
        });
        return;
      }
      if (!this.baseFormData.gender) {
        this.$message({
          message: '请选择性别',
          type: "error"
        });
        return;
      }

      if(!this.relationFormData.relationName){
        this.$message({
          message: '请输入关系',
          type: "error"
        });
        return;
      }

      if (!this.baseFormData.idcard || this.baseFormData.idcard.length != 18) {
        this.$message({
          message: '请输入18位身份证号码',
          type: "error"
        });
        return;
      }

      if (!this.detail.height) {
        this.$message({
          message: '请输入身高',
          type: "error"
        });
        return;
      }

      if (!this.detail.weight) {
        this.$message({
          message: '请输入体重',
          type: "error"
        });
        return;
      }

      if (!this.detail.waist) {
        this.$message({
          message: '请输入腰围',
          type: "error"
        });
        return;
      }

      if (!this.detail.sbp) {
        this.$message({
          message: '请输入血压',
          type: "error"
        });
        return;
      }

      if (!this.detail.dbp) {
        this.$message({
          message: '请选择血压',
          type: "error"
        });
        return;
      }

      if(!this.baseFormData.phone){
        this.$message({
          message: '请输入电话',
          type: "error"
        });
        return;
      }

      if (!this.baseFormData.managerHospital) {
        this.$message({
          message: '请选择机构名称',
          type: "error"
        });
        return;
      }

      if (!this.baseFormData.payWay) {
        this.$message({
          message: '请选择医疗费用支付方式',
          type: "error"
        });
        return;
      }

      if (!this.baseFormData.provinceCode) {
        this.$message({
          message: '请选择现住址-省',
          type: "error"
        });
        return;
      }

      if (!this.baseFormData.cityCode) {
        this.$message({
          message: '请选择现住址-市',
          type: "error"
        });
        return;
      }

      if (!this.baseFormData.countyCode) {
        this.$message({
          message: '请选择现住址-区',
          type: "error"
        });
        return;
      }

      if (!this.baseFormData.townCode) {
        this.$message({
          message: '请选择现住址-乡镇',
          type: "error"
        });
        return;
      }

      if (!this.baseFormData.villageCode) {
        this.$message({
          message: '请选择现住址-村',
          type: "error"
        });
        return;
      }

      if (!this.baseFormData.houseNumber) {
        this.$message({
          message: '请输入门牌号',
          type: "error"
        });
        return;
      }

      if (this.allergyDrugArr.length == 0) {
        this.$message({
          message: '请选择药物过敏史',
          type: "error"
        });
        return;
      } else {
        this.baseFormData.allergyDrug = this.allergyDrugArr.join('，');
      }

      if (this.envRiskArr.length != 0) {
        this.baseFormData.envRisk = this.envRiskArr.join('，');
      }

      if (this.diseases.length > 0) {
        var arr = this.diseases.filter(item => {
          return item.name != null
        })
        this.baseFormData.diseases = arr;
      }

      if (this.surgerys.length > 0) {
        var arr = this.surgerys.filter(item => {
          return item.name != null
        })
        this.baseFormData.surgerys = arr;
      }

      if (this.wounds.length > 0) {
        var arr = this.wounds.filter(item => {
          return item.name != null
        })
        this.baseFormData.wounds = arr;
      }

      if (this.bloodTransHistory.length > 0) {
        var arr = this.bloodTransHistory.filter(item => {
          return item.name != null
        })
        this.baseFormData.bloodTransHistory = arr;
      }

      if (this.familyHistory.length > 0) {
        var arr = this.familyHistory.filter(item => {
          return item.category != null
        })

        var arr2 = [];
        for (var i = 0; i < arr.length; i++) {
          var item = arr[i];
          if (item.category == "家族史无") {
            item.name = "无";
          }
          arr2.push(item);
        }

        this.baseFormData.familyHistory = arr2;
        console.log(arr, this.baseFormData.familyHistory, "校验之后的结果")
      }

      if (this.baseFormData.diseases.length == 0) {
        this.$message({
          message: '请选择疾病史',
          type: "error"
        });
        return;
      }

      if (this.baseFormData.familyHistory.length == 0) {
        this.$message({
          message: '请选择家族史',
          type: "error"
        });
        return;
      }

      console.log('baseformdata====json===', this.baseFormData)
      console.log('baseformdata====string===', JSON.stringify(this.baseFormData))

      var birthday = this.baseFormData.idcard.substr(6, 8);
      this.baseFormData.birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
      this.relationFormData.contactName = this.baseFormData.name;
      this.relationFormData.contactPhone = this.baseFormData.phone;

      addPatientList(this.baseFormData).then((responese) => {
        if (responese.msg == "success") {
          this.$message({
            message: "新建居民档案成功!",
            type: "success"
          })
          this.relationFormData.healthNo = responese.data.healthNo;
          updateContactList(this.relationFormData).then(res => {
            console.log(res);
            if (res.msg == "success") {
              this.$message({
                message: "更新联系人信息成功！",
                type: "success"
              })
              var contentText = res.data;
              // 判断是否调用易患人群评估接口
              this.detail.age = this.getAge(this.baseFormData.birthday);
              if (this.detail.age >= 35) {
                this.detail.patientId = responese.data.patientId;
                this.detail.patientName = responese.data.name;
                this.detail.idcard = responese.data.idcard;
                this.detail.healthNo = responese.data.healthNo;
                this.detail.gender = responese.data.gender;

                this.detail.bmi = Number(this.detail.weight / (Math.pow(this.detail.height / 100, 2))).toFixed(2);

                console.log('detail====json===', this.detail)
                console.log('detail====string===', JSON.stringify(this.detail))
                console.log(this.detail.bmi, this.detail.age)
                addPatientEasyillDiabetsModel(this.detail).then(res => {
                  if (res.msg == "success") {
                    if (res.data.riskName == "糖易") {
                      this.$confirm('该患者为糖尿病易患人群！', '提示', {
                        confirmButtonText: '确定',
                        showCancelButton: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                        showClose: false,
                        type: 'warning'
                      }).then(action => {
                        if (action === 'confirm') {
                          console.log("添加到糖尿病易患人群列表！")
                        }
                      })
                    }
                    this.$emit("update")
                    this.showDialog = false;
                  }
                }).catch(error => {
                  console.log(error)
                })
              } else {
                this.$message({
                  message: "居民年龄未满35岁，不支持建立易患人群评估结果！",
                  type: "error"
                })
                this.$emit("update")
                this.showDialog = false;
              }
            }
          }).catch(err => {
            console.log(err);
          })
        } else if(res.code == "500") {
          this.$message({
            message: res.msg,
            type: "error"
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.container {
  height: 500px !important;
  overflow: auto !important;

  .checkGroup {
    display: flex;
  }
}

.newAddPatients::v-deep {
  .el-dialog {
    margin-top: 5vh !important;
  }
  .el-dialog__header {
    padding: 20px !important;
    padding-bottom: 10px !important;
  }

  .el-dialog__body {
    text-align: initial !important;
    padding: 25px 25px 30px !important;
  }

  .el-dialog__footer {
    text-align: inherit !important;
    padding-bottom: 10px !important;

  }


}



::v-deep {
  .el-descriptions-item__label.is-bordered-label {
    width: 120px !important;
  }

  .el-checkbox-group {
    width: 100px;
  }

  .el-input {
    width: 250px;
  }

  // .el-input__inner {
  //   width: 250px;
  // }

  .el-dialog__body {
    text-align: initial;
    padding: 25px 25px 30px
  }
}
</style>